import { HttpClient } from '@angular/common/http';
import { inject, provideAppInitializer } from '@angular/core';
import { IModuleTranslationOptions, ModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';

import { environment } from '../environments/environment';

function httpLoaderFactory(http: HttpClient) {
    const baseTranslateUrl = './assets';

    const options: IModuleTranslationOptions = {
        version: environment.version,
        modules: [
            {
                baseTranslateUrl,
                pathTemplate: '{baseTranslateUrl}/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.feature_login',
                pathTemplate: '{baseTranslateUrl}/angular-auth-feature-login/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.feature_signup',
                pathTemplate: '{baseTranslateUrl}/angular-auth-feature-signup/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.feature_change_password',
                pathTemplate: '{baseTranslateUrl}/angular-auth-feature-change-password/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.feature_accept_terms',
                pathTemplate: '{baseTranslateUrl}/angular-auth-feature-accept-terms/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.feature_user_menu',
                pathTemplate: '{baseTranslateUrl}/angular-auth-feature-user-menu/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.ui_components.google_button',
                pathTemplate: '{baseTranslateUrl}/angular-auth-ui-components/google-button/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.ui_components.set_password_form',
                pathTemplate: '{baseTranslateUrl}/angular-auth-ui-components/set-password-form/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.ui_components.email_form_field',
                pathTemplate: '{baseTranslateUrl}/angular-auth-ui-components/email-form-field/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'auth.feature_guards',
                pathTemplate: '{baseTranslateUrl}/angular-auth-feature-guards/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'ui_components.chart',
                pathTemplate: '{baseTranslateUrl}/angular-ui-components/i18n/chart/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'ui_components.favicon',
                pathTemplate: '{baseTranslateUrl}/angular-ui-components/i18n/favicon/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'ui_components.form',
                pathTemplate: '{baseTranslateUrl}/angular-ui-components/i18n/form/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'ui_components.scan_state',
                pathTemplate: '{baseTranslateUrl}/angular-ui-components/i18n/scan-state/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'ui_components.rating_icon',
                pathTemplate: '{baseTranslateUrl}/angular-ui-components/i18n/rating-icon/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'util_errors',
                pathTemplate: '{baseTranslateUrl}/angular-util-errors/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'util_common',
                pathTemplate: '{baseTranslateUrl}/angular-util-common/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'monitoring_button',
                pathTemplate: '{baseTranslateUrl}/angular-monitors-feature-monitoring-button/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'notifications',
                pathTemplate: '{baseTranslateUrl}/angular-notifications/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'payments',
                pathTemplate: '{baseTranslateUrl}/angular-payments/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'reports',
                pathTemplate: '{baseTranslateUrl}/angular-reports/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'scan.shell',
                pathTemplate: '{baseTranslateUrl}/angular-scan-shell/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'scan.util_common',
                pathTemplate: '{baseTranslateUrl}/angular-scan-util-common/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'scan.feature_execute',
                pathTemplate: '{baseTranslateUrl}/angular-scan-feature-execute/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'scan.feature_browse',
                pathTemplate: '{baseTranslateUrl}/angular-scan-feature-browse/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'scan.feature_view',
                pathTemplate: '{baseTranslateUrl}/angular-scan-feature-view/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'scan.feature_contact',
                pathTemplate: '{baseTranslateUrl}/angular-scan-feature-contact/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'security',
                pathTemplate: '{baseTranslateUrl}/angular-scan-feature-view/i18n/security.{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'target.feature_browse',
                pathTemplate: '{baseTranslateUrl}/angular-target-feature-browse/i18n/{language}'
            },
            {
                baseTranslateUrl,
                moduleName: 'target.feature_detail',
                pathTemplate: '{baseTranslateUrl}/angular-target-feature-detail/i18n/{language}'
            }
        ]
    };

    return new ModuleTranslateLoader(http, options);
}

export const provideTranslations = () => [
    provideTranslateService({
        loader: {
            provide: TranslateLoader,
            useFactory: httpLoaderFactory,
            deps: [ HttpClient ]
        },
        defaultLanguage: environment.defaultLanguage
    }),
    provideAppInitializer(() => {
        const translateService = inject(TranslateService);
        translateService.currentLang = environment.defaultLanguage;
    })
];
